module.exports = __webpack_public_path__ + "img/7.0b8c00b8.jpg";